import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const Shield = (props) => (_jsxs("span", { className: "d-inline-flex align-items-center gap-1 text-muted", title: props.label || 'District verified', style: { fontSize: '0.75rem' }, children: [_jsx("i", { className: "bi bi-shield-check", style: { color: '#0d6efd' } }), props.label && _jsx("span", { className: "text-primary", children: props.label })] }));
export default Shield;
